<template>
  <div class="create-survey-wrapper">
    <h1>Umfrage bearbeiten</h1>
<!--    <AdaButton :loading="loading" style="width: auto;margin-bottom: 18px" title="Zählpixel kopieren (Test)"
               @click="copyScript('test')"
               type="createButton"></AdaButton>
    <AdaButton :loading="loading" style="width: auto;margin-bottom: 18px" title="Zählpixel kopieren (Kontroll)"
               @click="copyScript('control')"
               type="createButton"></AdaButton>-->
    <SurveyForm v-if="loaded" v-model="model"></SurveyForm>
    <AdaButton :loading="loading" style="width: 100%" title="Umfrage aktualisieren" @click="updateSurvey"
               icon="icon-add"
               type="fullWidthButton"></AdaButton>
  </div>
</template>

<script>

import AdaButton from "../components/AdaButton";
import {RepositoryFactory} from "../scripts/RepositoryFactory";
import SurveyForm from "../components/SurveyForm";

const SurveysRepository = RepositoryFactory.get('surveys');

export default {
  name: "EditSurvey",
  components: {
    AdaButton,
    SurveyForm
  },
  data: function () {
    return {
      model: {},
      loaded: false,
      loading: false
    }
  },
  computed: {},
  methods: {
    async updateSurvey() {
      try {
        this.loading = true;
        let res = await SurveysRepository.updateSurvey(this.$route.params.id, this.model);
        this.loading = false;
        if (typeof res.data.error !== 'undefined' && res.data.error !== null) {
          this.$noty.warning('Die Umfrage wurde aktualisiert, die Umfrage ID konnte aber nicht bei den ' +
              'Creatives eingetragen werden. Mögliche Ursache: falsche Creative IDs. Fehler: ' + res.data.error, {
            timeout: 10000
          });
        } else if (res.data.warning !== null) {
          this.$noty.warning(res.data.warning);
        } else {
          this.$noty.success('Die Umfrage wurde erfolgreich aktualisiert');
        }
        await this.$router.push('/surveys');
      } catch (e) {
        this.loading = false;
        this.$noty.error("Fehler bei der Aktualisierung: \n" + e.response.data.error);
      }
    },
    async getSurvey() {
      try {
        const {data} = await SurveysRepository.getOne(this.$route.params.id);
        this.model = data;
        this.loaded = true;
      } catch (e) {
        this.$noty.error("Umfrage konnte nicht geladen werden: \n" + e.response.data.error);
      }
    },
    copyScript(group) {
      //eslint-disable-next-line
      let zaehlpixelUrl = `${process.env.VUE_APP_BACKEND_URL}/api/surveys/${this.model.id}/participate?group=${group}`;
      this.copyTextToClipboard(zaehlpixelUrl);
    },
    fallbackCopyTextToClipboard(text) {
      let textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err);
      }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard(text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(function () {
        console.log('Async: Copying to clipboard was successful!');
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    }

  },
  mounted() {
    this.getSurvey();
  }
}
</script>
<style lang="scss" scoped>

.create-survey-wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 600px;
}

.create-form {
  width: 600px;
}

.create-form > div {
  margin-bottom: 20px;
}

.split-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

</style>